import { Type } from 'class-transformer';
import { List } from '@/models/list';
import { Facility } from '@/models/facility';

export class Facilities extends List {
  @Type(() => Facility)
  results!: Facility[];
}
